import { AfterViewInit, Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'xpo-select-cell-editor',
  templateUrl: './select-editor.component.html',
  styleUrls: ['./select-editor.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'xpo-AgGrid-cellEditor--select',
  },
})
export class SelectEditorComponent implements ICellEditorAngularComp, AfterViewInit {
  options: any[];
  params: any;
  selectControl = new FormControl();

  @ViewChild('optionsList') selectRef: MatSelect;

  agInit(params): void {
    this.params = params;
    this.options = params.optionsEnum ? Object.values(params.optionsEnum) : params.options;
    this.selectControl.setValue(this.selectControl.value || this.params.value);
  }

  ngAfterViewInit(): void {
    this.selectRef.open();
  }

  onFocusOut(e): void {
    if (!e.relatedTarget) {
      this.params.api.stopEditing();
    }
  }

  onOptionSelected(): void {
    this.params.api.stopEditing();
  }

  getValue(): any {
    return this.selectControl.value || this.params.value;
  }
}
